import { useState, useEffect } from 'react'
import { branchService } from '../services/branchService'
import type { BranchOffice } from '../types'

export function useBranch(id: number) {
  const [data, setData] = useState<BranchOffice | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const branch = await branchService.getById(id)
        setData(branch)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Error al cargar sucursal')
      } finally {
        setIsLoading(false)
      }
    }
    fetchData()
  }, [id])

  return { data, isLoading, error }
}
